/**
 * pinnedNavSlice
 *
 * Plain reducer (matching project pattern) for pinned sidebar nav items.
 * Each item: { title: string, path: string }
 *
 * Persisted via redux-persist so pins survive page refresh.
 */

const initialState = {
  pinnedItems: [],
  loading: false,
  error: null,
};

const pinnedNavReducer = (state = initialState, action) => {
  switch (action.type) {
    case "pinnedNav/fetchPinsStart":
      return { ...state, loading: true, error: null };

    case "pinnedNav/fetchPinsSuccess":
      return { ...state, loading: false, pinnedItems: action.payload };

    case "pinnedNav/fetchPinsFailure":
      return { ...state, loading: false, error: action.payload };

    case "pinnedNav/togglePin": {
      const item = action.payload; // { title, path }
      const exists = state.pinnedItems.some((p) => p.path === item.path);
      return {
        ...state,
        pinnedItems: exists
          ? state.pinnedItems.filter((p) => p.path !== item.path)
          : [...state.pinnedItems, { title: item.title, path: item.path }],
      };
    }

    case "pinnedNav/setPinnedItems":
      return { ...state, pinnedItems: action.payload };

    case "pinnedNav/removePin":
      return {
        ...state,
        pinnedItems: state.pinnedItems.filter((p) => p.path !== action.payload),
      };

    default:
      return state;
  }
};

export default pinnedNavReducer;

// ─── Action creators ──────────────────────────────────────────────────────────

export const fetchPinsStart = () => ({ type: "pinnedNav/fetchPinsStart" });

export const fetchPinsSuccess = (data) => ({
  type: "pinnedNav/fetchPinsSuccess",
  payload: data,
});

export const fetchPinsFailure = (msg) => ({
  type: "pinnedNav/fetchPinsFailure",
  payload: msg,
});

export const togglePin = (item) => ({
  type: "pinnedNav/togglePin",
  payload: item,
});

export const setPinnedItems = (items) => ({
  type: "pinnedNav/setPinnedItems",
  payload: items,
});

export const removePin = (path) => ({
  type: "pinnedNav/removePin",
  payload: path,
});
